/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Panel Queries";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="warning"><_components.p>{"All panel types except Markdown and Service topology use queries."}</_components.p><_components.p>{"Queries that return an extremely large number of data points or invalid results\ncan result in panel errors. For example, a query might return an error for exceeding\nserver resource limits."}</_components.p><_components.p>{"Observability Platform reports these errors with an icon that appears in the corner\nof the "}<_components.strong>{"Preview"}</_components.strong>{" pane of the "}<_components.strong>{"Add panel"}</_components.strong>{" or "}<_components.strong>{"Edit panel"}</_components.strong>{" interfaces, or on the\npanel when viewing it on the dashboard. Hold the pointer over the icon to view the\nerror message."}</_components.p></Alert>;
}

export default MDXLayout